<template>
  <div class="login container align-left">
    <section class="section">
      <div class="container">
        <h1 class="title is-2">
          Bitte melde dich an, um diese Seite zu besuchen.
        </h1>

        <b-button type="is-primary" size="is-medium" @click="login">
          Zur Anmeldung
        </b-button>
      </div>
    </section>
  </div>
</template>

<script>
import { AuthClient, authClient } from "@/auth0";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Login extends Vue {
  // Log the user in
  async login() {
    await authClient.login();
  }
}
</script>

<style scoped lang="scss">
.login {
  button {
    margin-top: 36px;
  }
}
</style>
